import React, { useState } from "react";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Accuracy_Report_Filter from "./accuracy_report_filter/Accuracy_Report_Filter";
import Accuracy_Report_Table from "./accuracy_report_table/Accuracy_Report_Table";


const Accuracy_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Accuracy_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Accuracy_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Accuracy Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Accuracy_Report;
